require('../../shared/singleGameService');
require('../../shared/singleClipService');
require('../../shared/clipCategoryService');
require('../../shared/dataTransformers/clockTimeTransformer');
require('../../shared/dataTransformers/clipTransformer');

angular.module('app.player.tagEventController', [
  'app.shared.singleGameService',
  'app.shared.singleClipService',
  'app.player.playerSharedDataService',
  'app.shared.clipCategoryService',
  'app.shared.dataTransformers.clockTimeTransformer',
  'app.shared.dataTransformers.clipTransformer',
])
  .controller('app.player.tagEventController', [
    '$scope',
    'app.shared.singleGameService',
    'app.shared.singleClipService',
    'app.player.playerSharedDataService',
    'app.shared.clipCategoryService',
    'app.shared.dataTransformers.clockTimeTransformer',
    'app.shared.dataTransformers.clipTransformer',
    '$rootScope',
    function ($scope, singleGame, singleClip, playerSharedData, clipCategoryService, clockTimeTransformer, clipTransformer, $rootScope) {
      "use strict";

      $scope.selectedClip = null;
      $scope.clipCategoryMeta = {
        type: null,
        team: null
      };

      $scope.activeLine = {
        away: {
          offense: null,
          defense: null
        },
        home: {
          offense: null,
          defense: null
        }
      };

      $scope.sharedData = playerSharedData;

      $scope.error = singleClip.error;

      let tagSelectLocationCanvasProps = {
        ilocx: null,
        ilocy: null,
        fillStyle: '#7ed321',
        fillDiameter: 4,
        id: null,
        context: null,
      };

      $scope.tagEventClick = function (eventName) {
        switch (eventName) {
          case 'save':
            if ($scope.selectedClip) {
              if (_.isEmpty($scope.selectedClip.strclipname)) {
                $scope.selectedClip.strclipname =
                  _.find($scope.clipCategories, {
                    iclipcategoryid: $scope.selectedClip.iclipcategoryid_fk
                  })
                    .strclipcategory;
              }

              let clipStartTime = (parseInt(($scope.selectedClip.startClockTime.hour * 60) * 60) + parseInt($scope.selectedClip.startClockTime.minute * 60) + parseInt($scope.selectedClip.startClockTime.second));
              let clipEndTime = (parseInt(($scope.selectedClip.endClockTime.hour * 60) * 60) + parseInt($scope.selectedClip.endClockTime.minute * 60) + parseInt($scope.selectedClip.endClockTime.second));

              $scope.selectedClip.strsourcestart = clipStartTime;
              $scope.selectedClip.strsourceduration = clipEndTime - clipStartTime;

              let startTime = singleClip.transformer.getStartTime($scope.selectedClip);
              let duration = clipEndTime - clipStartTime;
              $scope.selectedClip.strsourceduration = duration;

              Object.assign($scope.selectedClip, window.jwPlayerMod.fragPosition($scope.player, startTime));

              singleClip.updateClip($scope.selectedClip.iclipid, $scope.selectedClip)
                .then((response) => {
                  let data = response.data;
                  if (data.error) {
                    $scope.error = data.error;
                  } else {
                    $scope.error = null;

                    let indexToUpdate = singleGame.clips.findIndex((clip) => {
                      return $scope.selectedClip.iclipid === clip.iclipid
                    });

                    singleGame.clips[indexToUpdate] = clipTransformer.transformToUi(data);
                    $rootScope.$broadcast('assign_timeline_clips');
                    $scope.$emit('show_hide_clip_details', false);
                  }
                });
            }
            break;
          case 'delete':
            singleClip.delete($scope.selectedClip.iclipid)
              .then(() => {
                let indexToDelete = singleGame.clips.findIndex((clip) => {
                  return $scope.selectedClip.iclipid === clip.iclipid
                });

                singleGame.clips.splice(indexToDelete, 1);
                $rootScope.$broadcast('assign_timeline_clips');
              });
            break;
        }

        if (eventName !== 'save') {
          $scope.$emit('show_hide_clip_details', false);
          $scope.error = null;
        }
      };

      $scope.setLine = (team_type, line_number, positionSet) => {
        if ($scope.selectedClip) {
          let lineups = singleGame.data ? singleGame.data.lineup : null;
          let team = singleGame.data ? singleGame.data[team_type + 'team'] : null;

          if (team && lineups && lineups[team.iteamid] && lineups[team.iteamid][line_number]) {
            let lineup = lineups[team.iteamid][line_number];
            let prefix = 'i' + team_type.substr(0, 1);
            let offensivePositions = ['lw', 'rw', 'c'];
            let defensivePositions = ['ld', 'rd'];

            if (!$scope.selectedClip[prefix + 'g'] && lineups[team.iteamid][1]) {
              $scope.selectedClip[prefix + 'g'] = lineups[team.iteamid][1]['ig'];
            }

            let positions = positionSet === 'defense' ? defensivePositions : offensivePositions;
            _.forEach(positions, (position) => {
              $scope.selectedClip[prefix + position] = lineup['i' + position];
            });
          }
        }
      };

      $scope.tagSelectLocationClick = (event) => {
        $scope.tagSelectLocation(event.offsetX, event.offsetY);
      };

      $scope.tagSelectLocation = function (x, y) {
        if (x) {
          $scope.selectedClip.ilocx = x;
        }
        if (y) {
          $scope.selectedClip.ilocy = y;
        }

        if ($scope.selectedClip) {
          //get id & context
          tagSelectLocationCanvasProps.id = document.getElementById('selectTagLocationCanvas');
          if (tagSelectLocationCanvasProps.id) {
            tagSelectLocationCanvasProps.context = tagSelectLocationCanvasProps.id.getContext("2d");

            // clear canvas
            tagSelectLocationCanvasProps.context.clearRect(0, 0, tagSelectLocationCanvasProps.id.width, tagSelectLocationCanvasProps.id.height);

            // set ilocx & ilocy
            tagSelectLocationCanvasProps.ilocx = $scope.selectedClip.ilocx;
            tagSelectLocationCanvasProps.ilocy = $scope.selectedClip.ilocy;

            // draw dot
            if (tagSelectLocationCanvasProps.ilocx || tagSelectLocationCanvasProps.ilocy) {
              tagSelectLocationCanvasProps.context.beginPath();
              tagSelectLocationCanvasProps.context.fillStyle = tagSelectLocationCanvasProps.fillStyle;
              tagSelectLocationCanvasProps.context.arc(
                tagSelectLocationCanvasProps.ilocx, tagSelectLocationCanvasProps.ilocy,
                tagSelectLocationCanvasProps.fillDiameter,
                0, 2 * Math.PI
              );
              tagSelectLocationCanvasProps.context.stroke();
              tagSelectLocationCanvasProps.context.lineWidth = 4;
              tagSelectLocationCanvasProps.context.fill();
            }
          }
        }
      };

      $scope.setTimeFromPlayer = (type) => {
        if ($scope.selectedClip) {
          let currentPosition = Math.round($scope.player.getPosition());
          let currentDuration = Math.round($scope.player.getDuration());
          let playerTime;

          if (currentDuration < 0) {
            playerTime = -(currentDuration - currentPosition);
          }
          else {
            playerTime = currentPosition;
          }

          let clockTime = singleClip.transformer.secondsToClockTime(playerTime);

          switch (type) {
            case 'startClockTime':
              $scope.selectedClip.startClockTime = clockTime;
              let fragPosition = window.jwPlayerMod.fragPosition($scope.player);
              Object.assign($scope.selectedClip, fragPosition);
              break;
            case 'endClockTime':
              $scope.selectedClip.endClockTime = clockTime;
              break;
            case 'clockTime':
              $scope.selectedClip.clockTime = clockTime;
              break;
          }
        }
      };

      $scope.selectShooter = (teamType, playerNumber) => {
        if ($scope.selectedClip) {
          $scope.selectedClip.strgoalteam = teamType;
          $scope.selectedClip.igoal = playerNumber;
        }
      };

      $scope.selectAssist = (teamType, playerNumber, event) => {
        if ($scope.selectedClip) {
          if (
            $scope.selectedClip.strgoalteam
            && $scope.selectedClip.strgoalteam === teamType
            && $scope.selectedClip.igoal) {
            if (!Array.isArray($scope.selectedClip.goalAssist)) {
              $scope.selectedClip.goalAssist = [];
            }

            let assistIndex = $scope.selectedClip.goalAssist.indexOf(playerNumber);
            if (assistIndex === -1) {
              $scope.selectedClip.goalAssist.push(playerNumber);
            }
            else {
              $scope.selectedClip.goalAssist.splice(assistIndex, 1);
            }
          }
          else {
            alert('Please select a shooter first.');
            if (event) {
              event.preventDefault();
            }
          }
        }
      };

      $scope.isShooterSelected = (teamType, playerNumber) => {
        playerNumber = parseInt(playerNumber);

        return $scope.selectedClip
          && $scope.selectedClip.strgoalteam === teamType
          && parseInt($scope.selectedClip.igoal) === playerNumber;
      };

      $scope.isAssistSelected = (teamType, playerNumber) => {
        if ($scope.selectedClip) {
          if ($scope.selectedClip.strgoalteam === teamType) {
            if (Array.isArray($scope.selectedClip.goalAssist)) {
              return $scope.selectedClip.goalAssist.indexOf(playerNumber) !== -1;
            }
          }
        }
        return false;
      };

      $scope.scrubPlayerToStartTime = () => {
        let seekTime = clockTimeTransformer.clockTimeToSeconds($scope.selectedClip.startClockTime);
        let fragPosition = window.jwPlayerMod.fragPosition($scope.player, seekTime);
        Object.assign($scope.selectedClip, fragPosition);
      };

      $scope.getSubcategoryStrengths = () => {
        if ($scope.selectedClip && $scope.selectedClip.subcategory_id) {
          clipCategoryService.getSubcategoryStrengths({ subcategories: $scope.selectedClip.subcategory_id })
            .then((response) => {
              let data = response.data;

              if (data.error) {
                alert(data.error);
              }
              else {
                $scope.clipSubcategoryStrengths = data;
              }
            });
        }
      };

      let init = function (params) {
        if (params && params.clip && params.clip.iclipid) {
          $scope.selectedClip = angular.copy(params.clip);
          $scope.tagSelectLocation();

          if (params.show_editor) {
            $scope.getSubcategoryStrengths();
            $scope.$emit('show_hide_clip_details', params.show_editor);
          } else {
            $scope.$emit("select_timeline_tab");
          }
        }
      };

      let getCategoryType = (category) => {
        let types = ['goal'];
        for (let type of types) {
          if (clipCategoryService.isType(category, type)) {
            return type;
          }
        }
        return null;
      };

      let getCategoryTeam = (category) => {
        let teams = ['home', 'away'];
        for (let team of teams) {
          if (clipCategoryService.isTeam(category, team)) {
            return team;
          }
        }
        return null;
      };


      $scope.$on('instant_replay_created', function (evt, data) {
        init(data);
      });

      $scope.$on('assign_clip_categories', () => {

      })

      $scope.$watchCollection(
        () => {
          return $scope.selectedClip;
        },
        (newVal) => {
          $scope.activeLine = {
            away: {
              offense: null,
              defense: null
            },
            home: {
              offense: null,
              defense: null
            }
          };

          if (singleGame.data) {
            let game = singleGame.data;
            let lineups = game.lineup;
            let teams = {
              away: game.awayteam.iteamid,
              home: game.hometeam.iteamid
            };

            if (lineups) {
              for (let teamType in teams) {
                let offensiveLineFound = false;
                let defensiveLineFound = false;
                let prefix = teamType === 'home' ? 'ih' : 'ia';

                if (teams.hasOwnProperty(teamType)) {
                  let teamId = teams[teamType];

                  for (let lineNumber in lineups[teamId]) {
                    if (lineups[teamId].hasOwnProperty(lineNumber)) {
                      let lineup = lineups[teamId][lineNumber];

                      if (!offensiveLineFound) {
                        if (lineup.ilw || lineup.irw || lineup.ic) {
                          if (
                            newVal[prefix + 'lw'] === lineup.ilw
                            && newVal[prefix + 'rw'] === lineup.irw
                            && newVal[prefix + 'c'] === lineup.ic
                          ) {
                            $scope.activeLine[teamType].offense = lineNumber;
                            offensiveLineFound = true;
                          }
                        }
                      }

                      if (!defensiveLineFound) {
                        if (lineup.ild || lineup.ird) {
                          if (
                            newVal[prefix + 'ld'] === lineup.ild
                            && newVal[prefix + 'rd'] === lineup.ird
                          ) {
                            $scope.activeLine[teamType].defense = lineNumber;
                            defensiveLineFound = true;
                          }
                        }
                      }
                    }
                    if (offensiveLineFound && defensiveLineFound) break;
                  }
                }
              }
            }
          }

          if ($scope.selectedClip && playerSharedData.clipCategories.length) {
            _.forEach(playerSharedData.clipCategories, (category) => {
              if ($scope.selectedClip.iclipcategoryid_fk === category.iclipcategoryid) {
                $scope.clipCategoryMeta = {
                  type: getCategoryType(category),
                  team: getCategoryTeam(category)
                };
              }
            });
          }
        }
      )
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/tagEvent/tagEventController.js